export function formatDateOnly(value: string | null | undefined): string {
  const raw = (value ?? "").trim().replace("T", " ");
  const datePart = raw.split(/\s+/).filter(Boolean)[0] ?? "";
  return datePart || "—";
}

export function formatDateAndTime(
  value: string | null | undefined,
): { datePart: string; formattedTime: string } {
  const raw = (value ?? "").trim().replace("T", " ");
  const parts = raw.split(/\s+/).filter(Boolean);
  const datePart = parts[0] ?? "";
  const timePart = parts.length > 1 ? parts[1] : "";
  const formattedTime = (() => {
    const match = timePart.match(/^(\d{1,2}):(\d{2})/);
    if (!match) return timePart;
    return `${match[1].padStart(2, "0")}:${match[2]}`;
  })();
  return { datePart: datePart || "—", formattedTime };
}

